<template>
  <svg width="12" height="16" viewBox="0 0 12 16" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M11.6667 6H10.6667V4.66666C10.6667 2.09344 8.57325 0 6 0C3.42675 0 1.33334 2.09344 1.33334 4.66666V6H0.333344C0.149094 6 0 6.14909 0 6.33334V14.6667C0 15.402 0.597969 16 1.33334 16H10.6667C11.402 16 12 15.402 12 14.6667V6.33334C12 6.14909 11.8509 6 11.6667 6ZM6.99806 12.9632C7.00847 13.0573 6.97822 13.1517 6.91506 13.2223C6.85191 13.293 6.76141 13.3333 6.66669 13.3333H5.33334C5.23863 13.3333 5.14812 13.293 5.08497 13.2223C5.02181 13.1517 4.99153 13.0573 5.00197 12.9632L5.21225 11.0723C4.87078 10.8239 4.66669 10.431 4.66669 10C4.66669 9.26466 5.26466 8.66666 6.00003 8.66666C6.73541 8.66666 7.33337 9.26462 7.33337 10C7.33337 10.431 7.12928 10.8239 6.78781 11.0723L6.99806 12.9632ZM8.66666 6H3.33334V4.66666C3.33334 3.19628 4.52962 2 6 2C7.47038 2 8.66666 3.19628 8.66666 4.66666V6Z"
        fill="currentColor"/>
  </svg>

</template>

<script>
export default {
  name: "IconLock"
}
</script>

<style scoped>

</style>